import { useQuery } from "@tanstack/react-query";
import { attemptGetAllBrands } from "../../api/OrgApi";

export const useGetAllBrands = (orgID, options = {}) => {
  return useQuery({
    queryKey: ["org-brands", orgID],
    queryFn: () => attemptGetAllBrands(orgID),
    enabled: !!orgID,
    select: (response) => response.data,
    refetchOnWindowFocus: false,
    ...options,
  });
};
